/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ansprechpersonextern2Inputs */

const de__field_ansprechpersonextern2 = /** @type {(inputs: _Field_Ansprechpersonextern2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`externe Ansprechsperson`)
};

/**

* @param {_Field_Ansprechpersonextern2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_ansprechpersonextern2 = /** @type {((inputs?: _Field_Ansprechpersonextern2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ansprechpersonextern2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_ansprechpersonextern2(inputs)
});
export { _field_ansprechpersonextern2 as "_field_ansprechPersonExtern" }